<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <TsaPendingPaymentTip type="userAccount_overview"></TsaPendingPaymentTip>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>{{
                        $route.meta.title
                    }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-row type="flex" class="row-bg base-bg" justify="center" v-if="$getlocalStorage('userData').parentId=='0'">
                <el-col :lg="6" :md="6">
                    <div class="baseTitle">
                        <p>通用时间戳（个）：</p>
                        <p style="margin-top:10px"><b>{{generalTsCount}} </b>个</p>
                        <el-button
                            round
                            @click="goBuy"
                            >去购买</el-button
                        >
                    </div>
                </el-col>
                <el-col :lg="6" :md="6">
                    <div class="baseTitle">
                        <p>确权专用时间戳（个）：</p>
                        <p style="margin-top:10px"><b>{{opusTsCount}} </b>个</p>
                        <el-button
                            round
                            style="visibility:hidden;"
                            >去购买</el-button
                        >
                    </div>
                </el-col>
                <el-col :lg="6" :md="6">
                    <div class="baseTitle">
                        <p>即将过期时间戳（个）： </p>
                        <p style="margin-top:10px;"><b style="color: white">{{expireTsCount}} </b>个</p>
                        <el-button
                            round
                            @click="goLook"
                            >去查看</el-button
                        >
                    </div>
                </el-col>
                <el-col :lg="6" :md="6">
                    <div class="baseTitle">
                        <p>累计充值总金额： </p>
                        <p style="margin-top:10px"><b style="color: white">{{totalRechargeAmount}} </b>元</p>
                        <el-button
                            round
                            style="visibility:hidden;"
                            >去查看</el-button
                        >
                    </div>
                </el-col>
            </el-row>
            <el-row type="flex" class="row-bg base-bg" justify="center" v-else>
                <el-col :lg="6" :md="6">
                    <div class="baseTitle">
                        <p>主账号通用时间戳（个）：</p>
                        <p style="margin-top:10px"><b>{{generalTsCount}} </b>个</p>
                    </div>
                </el-col>
                <el-col :lg="6" :md="7">
                    <div class="baseTitle">
                        <p>主账号确权专用时间戳（个）：</p>
                        <p style="margin-top:10px"><b>{{opusTsCount}} </b>个</p>
                    </div>
                </el-col>
                <el-col :lg="6" :md="5">
                    <div class="baseTitle">
                        <p>当前已用时间戳（个）： </p>
                        <p style="margin-top:10px"><b>{{currentConsumeTsCount}} </b>个</p>
                    </div>
                </el-col>
                <el-col :lg="6" :md="6">
                    <div class="baseTitle">
                        <p>当前最大使用限制数： </p>
                        <p style="margin-top:10px" v-if="consumeLimitTsCount==-1"><b style="color: white">无限制</b></p>
                        <p style="margin-top:10px" v-else><b style="color: white">{{consumeLimitTsCount}} </b>个</p>
                    </div>
                </el-col>
            </el-row>
            <div class="filterMonth" style="margin-top:20px">
                <el-date-picker
                    v-model="filterData"
                    @change="datetime"
                    type="month"
                    value-format="yyyy-MM"
                    :picker-options="pickerOptions"
                    placeholder="选择月">
                </el-date-picker>
            </div>
            <el-row
                type="flex"
                class="row-bg"
                justify="center"
                style="width: 100%; margin-top: 20px;padding-bottom:5px"
            >
                <el-col :span="12">
                    <div class="tagView">
                        <div class="title_aside"></div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item
                                >产品消费分布</el-breadcrumb-item
                            >
                        </el-breadcrumb>
                    </div>
                    <Echarts
                        id="echarts1"
                        :sysData="consumeData"
                        text="无消费"
                        class="echarts"
                        :totalNum="totalConsumeNum"
                    />
                </el-col>
                <el-col :span="12">
                    <div v-if="$getlocalStorage('userData').parentId=='0'">
                        <div class="tagView">
                            <div class="title_aside"></div>
                            <el-breadcrumb separator-class="el-icon-arrow-right">
                                <el-breadcrumb-item
                                    >时间戳总数购买平台分布</el-breadcrumb-item
                                >
                            </el-breadcrumb>
                        </div>
                        <Echarts
                            id="echarts2"
                            :sysData="rechargeData"
                            text="无购买"
                            class="echarts"
                            :totalNum="totalRechargeNum"
                        />
                    </div>
                </el-col>
            </el-row>
            <div class="hline" 
                style="position:absolute; width:100%; height:15px; background:#f8fafb;
                left:0;
                "
                v-if="$getlocalStorage('userData').parentId=='0'"
            >
            </div>
            <el-row class="row-bg" style="width: 100%; margin-top: 35px" v-if="$getlocalStorage('userData').parentId=='0'">
                <el-col :span="24">
                    <div class="tagView">
                        <div class="title_aside"></div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>已购订单</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <div class="table">
                        <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-bottom:20px">
                            <el-tab-pane
                                label="正在消费"
                                name="one"
                            ></el-tab-pane>
                            <el-tab-pane
                                label="待消费"
                                name="two"
                            ></el-tab-pane>
                            <el-tab-pane
                                label="消费完成"
                                name="three"
                            ></el-tab-pane>
                            <el-tab-pane
                                label="已过期"
                                name="four"
                            ></el-tab-pane>
                            <el-tab-pane
                                label="已冻结"
                                name="five"
                            ></el-tab-pane>
                            <el-tab-pane
                                label="已退款"
                                name="six"
                                v-if="isShow"
                            ></el-tab-pane>
                            <el-tab-pane
                                label="已转出"
                                name="seven"
                                v-if="isShow2"
                            ></el-tab-pane>
                        </el-tabs>
                        <div>
                            <ExTable
                                :isIndex="false"
                                :table-list="tableData"
                                :header="header"
                                height="300"
                                :total="total"
                                :activeIndex="searchParam.page"
                                @clickPage="clickPage"
                                @clickSize="clickSize"
                            />
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </el-row>
</template>
<script>
import Echarts from "@com/Echarts";
import ExTable from "@com/ExTable";
import moment from 'moment'
import {overviewNum,overviewChildNum,userOrderOutflow} from "@http/overview/index";
import {userOrderRefund} from "@http/order/index";
import {orderData} from "@http/order/index";
import TsaPendingPaymentTip from '@/components/pendingPaymentTip'
import {formatDate,filterParams,regroupData,numTotal,getMonthDateRange} from "@/utils/filter";
export default {
    name: "overview",
    components: { ExTable,Echarts, TsaPendingPaymentTip },
    data() {
        return {
            isShow:false,
            isShow2:false,
            balance:'',
            opusTsCount:'',
            generalTsCount:'',
            expireTsCount:'',
            totalRechargeAmount:'',
            consumeLimitTsCount:'',
            currentConsumeTsCount:'',
            childCount:{},
            rechargeData: [],
            consumeData:[],
            totalConsumeNum:'0',
            totalRechargeNum:'0',
            activeName:'one',
            header: [
                { prop: "id", label: "订单号" },
                {
                    prop: "createdAt",
                    label: "购买时间",
                    formatter: (row) => {
                        return formatDate(row.createdAt);
                    },
                },
                {
                    prop: "suiteName",
                    label: "服务包名称",
                },
                {
                    prop: "tsCount",
                    label: "时间戳总数",
                    formatter: (row) => {
                        return row.tsCount + "个";
                    },
                },
                {
                    prop: "remainTsCount",
                    label: "剩余个数",
                    formatter: (row) => {
                        return row.remainTsCount + "个";
                    },
                },
                {
                    prop: "suiteValidityPeriod",
                    label: "有效期",
                    formatter: (row) => {
                        if (
                            row.suiteValidityPeriod == 0 ||
                            !row.suiteValidityPeriod
                        ) {
                            return "永久有效";
                        } else {
                            return row.suiteValidityPeriod + "天";
                        }
                    },
                },
                // {
                //     prop: "tsCount",
                //     label: "consumeStatus",
                // },
                {
                    prop: "startAt",
                    label: "订单生效时间",
                    formatter: (row) => {
                        if((row.consumeStatus==1 && row.type==1) || (row.suiteValidityPeriod == 0 ||
                            !row.suiteValidityPeriod)){
                            return '--'
                        }
                        if(!row.startAt){
                            return '--'
                        }
                        return formatDate(row.startAt);
                    },
                },
                {
                    prop: "expiredAt",
                    label: "订单到期时间",
                    formatter: (row) => {
                        if((row.consumeStatus==1 && row.type==1) || (row.suiteValidityPeriod == 0 ||
                            !row.suiteValidityPeriod)){
                            return '--'
                        }
                        if(!row.expiredAt){
                            return '--'
                        }
                        return formatDate(row.expiredAt);
                    },
                },
            ],
            searchParam: {
                page: 1,
                size: 10,
                consumeStatus:2,
            },
            tableData:[],
            total:10,
            filterData:'',
            pickerOptions:{
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            }
        };
    },
    computed: {
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },
    async created(){
        this.filterData=moment(new Date()).format("YYYY-MM")
        let YYMM=this.filterData.split("-");
        let dateRange=getMonthDateRange(YYMM[0],YYMM[1]);  
        this.getTableData(filterParams(this.searchParam));
        if(this.$getlocalStorage('userData').parentId=='0'){
            this.getOverviewNum({
                startCreatedAt:dateRange.start,
                endCreatedAt:dateRange.end
            })
        }else{
            this.getChildOverviewNum({
                startCreatedAt:dateRange.start,
                endCreatedAt:dateRange.end
            })
        }
        let res2=await userOrderRefund()
        res2?.status==1?this.isShow=true : this.isShow=false;
        let res3=await userOrderOutflow();
        res3?.status==1?this.isShow2=true : this.isShow2=false;
    },
    mounted() {
        zhuge.track('用户中心_进入账户总览', {'渠道': this.channelCodeValue})
    },
    methods:{
        async getTableData(data) {
            let res = await orderData(data);
            this.tableData =res.data;
            this.total=res.total;
        },
        async getOverviewNum(data){
            let res = await overviewNum(data);
            this.balance=res.totalTsCount;
            this.expireTsCount=res.expireTsCount;
            this.opusTsCount=res.opusTsCount;
            this.generalTsCount=res.generalTsCount;
            this.totalRechargeAmount=res.totalRechargeAmount;
            this.rechargeData=regroupData(res.recharge);
            this.consumeData=regroupData(res.consume);
            this.totalConsumeNum=numTotal(this.consumeData)+'个';
            this.totalRechargeNum=numTotal(this.rechargeData)+'个';
        },
        async getChildOverviewNum(data){
            let res = await overviewChildNum(data);
            console.log(res)
            this.balance=res.totalTsCount;
            this.opusTsCount=res.opusTsCount;
            this.generalTsCount=res.generalTsCount;
            this.consumeLimitTsCount=res.consumeLimitTsCount;
            this.currentConsumeTsCount=res.currentConsumeTsCount;
            this.consumeData=regroupData(res.consume);
            this.totalConsumeNum=numTotal(this.consumeData)+'个';
        },
        handleClick(tab, event){
            this.searchParam.page=1;
            this.searchParam.size=10;
            switch (tab.name) {
                    case "one":
                        this.searchParam.consumeStatus =2;
                        this.getTableData(this.searchParam)
                        break;
                    case "two":
                        this.searchParam.consumeStatus =1;
                        this.getTableData(this.searchParam)
                        break;
                    case "three":
                        this.searchParam.consumeStatus =5;
                        this.getTableData(this.searchParam)
                        break;
                    case "four":
                        this.searchParam.consumeStatus =4;
                        this.getTableData(this.searchParam)
                        break;
                    case "five":
                        this.searchParam.consumeStatus =3;
                        this.getTableData(this.searchParam)
                        break;
                    case "six":
                        this.searchParam.consumeStatus =6;
                        this.getTableData(this.searchParam)
                        break;
                    case "seven":
                        this.searchParam.consumeStatus =7;
                        this.getTableData(this.searchParam)
                        break;
                }
        },
        async clickPage(page) {
            this.searchParam.page = page;
            this.getTableData(filterParams(this.searchParam));
        },
        async clickSize(size) {
            this.searchParam.page = 1;
            this.searchParam.size = size;
            this.getTableData(filterParams(this.searchParam));
        },
        datetime(e){
            console.log(e)
            if(e){
                let YYMM=e.split("-");
                let dateRange=getMonthDateRange(YYMM[0],YYMM[1]);
                if(this.$getlocalStorage('userData').parentId=='0'){
                    this.getOverviewNum({
                        startCreatedAt:dateRange.start,
                        endCreatedAt:dateRange.end
                    })
                }else{
                    this.getChildOverviewNum({
                        startCreatedAt:dateRange.start,
                        endCreatedAt:dateRange.end
                    })
                }
            }else{
                if(this.$getlocalStorage('userData').parentId=='0'){
                    this.getOverviewNum({})
                }else{
                    this.getChildOverviewNum({})
                }
            }
        },
        goBuy(){
            zhuge.track('用户中心_去购买', {'渠道': this.channelCodeValue},()=> {
                this.$router.push({path:'/userAccount/buy'})
            })
        },
        goLook(){
            zhuge.track('用户中心_查看过期', {'渠道': this.channelCodeValue},()=> {
                this.$router.push({path: '/userAccount/overview/expire'})
            })
        }
    }
};
</script>

<style scoped lang="less">
.mianContent{
    position: relative;
}
.base-bg {
    background: url("../../assets/images/user/account.png") center no-repeat;
    background-size: 100%;
    width: 100%;
    height: 146px;
    margin-top: 27px;
    display: flex;
    align-items: center;
    font-family: Source Han Sans CN;
}
.baseTitle {
    padding-left: 100px;
    p {
        font-size: 14px;
        color: #ffffff;
        b {
            font-size: 18px;
            color: #ffec16;
        }
    }
    .el-button {
        background:#3f7df7;
        border-radius: 27px;
        width: 94px;
        height: 34px;
        text-align: center;
        color: #fff;
        margin-top: 10px;
        border:1px solid #ccc;
        line-height:8px;
    }
    .el-button:hover{
        color:#3f7df7;
        background: #fff;
    }
}
.echarts {
    margin-top: 25px;
}
.table {
    width: 92%;
    margin: 0 auto;
}
.filterMonth{
    /deep/ .el-input__icon{
        line-height: 32px !important;
    }
}

@media screen and (max-width:1450px) {
    .base-bg {
        background-size: cover;
    }
    .baseTitle{
        padding-left: 50px;
    }
}
</style>
